import React, {useState, useCallback} from 'react';
import Img from 'gatsby-image';
import {mod} from '../helpers';
import styles from './styles/ImageGrid.module.scss';

const ImageGrid = ({images, renderModal, renderOverlay}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageIndex, setModalImageIndex] = useState(0);

    const openModal = (imageIndex) => {
        setModalImageIndex(imageIndex);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const showNextImage = useCallback(() => {
        setModalImageIndex(mod(modalImageIndex + 1, images.length));
    }, [setModalImageIndex, modalImageIndex, images]);

    const showPrevImage = useCallback(() => {
        setModalImageIndex(mod(modalImageIndex - 1, images.length));
    }, [setModalImageIndex, modalImageIndex, images]);

    return (
        <>
            <div className={styles.grid}>
                {images.map((image, index) => (
                    <div
                        key={image.id}
                        className={styles.imageWrapper}
                        onClick={() => openModal(index)}
                    >
                        <Img fixed={image.preview} className={styles.image} />
                        <div className={styles.overlay}>
                            {renderOverlay({index: index})}
                        </div>
                    </div>
                ))}
            </div>

            {isModalOpen && renderModal({
                index: modalImageIndex,
                close: closeModal,
                next: showNextImage,
                prev: showPrevImage,
            })}
        </>
    );
};

export default ImageGrid;
